import type { Locale } from 'date-fns'
import { enGB, es } from 'react-day-picker/locale'

/**
 * Locale del idioma activo (`i18n.language`) para date-fns y para los calendarios. Único sitio
 * que decide es/en: antes `DateField` y `SessionDateTimePicker` llevaban `es` fijo y pintaban
 * las fechas en español con la app en inglés.
 *
 * Son los locales de react-day-picker: los de date-fns ampliados con los textos de
 * accesibilidad del calendario («Ir al mes siguiente», «Hoy, …»). Con los de date-fns a pelo,
 * el calendario los anunciaba en inglés aunque la app estuviera en español.
 */
export function dateFnsLocale(language: string | undefined): Locale {
  return language?.startsWith('en') ? enGB : es
}
